/**
 * Back to top button (inc/back-to-top.php): <html> gets "ssf-to-top-on" once the page has scrolled
 * past one screen, and style.css fades the button in. A click glides to the top through Lenis when
 * smooth scroll runs, and moves keyboard focus to the header logo.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var button = document.querySelector( '.ssf-to-top' );

	if ( ! button || document.body.classList.contains( 'elementor-editor-active' ) ) {
		return;
	}

	var root = document.documentElement;
	var reducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
	var shown = false;
	var ticking = false;

	function update() {
		var next = ( window.scrollY || window.pageYOffset ) > window.innerHeight;
		if ( next !== shown ) {
			shown = next;
			root.classList.toggle( 'ssf-to-top-on', shown );
		}
		ticking = false;
	}

	window.addEventListener( 'scroll', function () {
		if ( ! ticking ) {
			ticking = true;
			window.requestAnimationFrame( update );
		}
	}, { passive: true } );

	button.addEventListener( 'click', function () {
		if ( window.ssfLenis ) {
			window.ssfLenis.scrollTo( 0 );
		} else {
			window.scrollTo( { top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' } );
		}

		var start = document.querySelector( '.ssf-header .ssf-logo a' ) || document.querySelector( '.skip-link' );
		if ( start ) {
			start.focus( { preventScroll: true } );
		}
	} );

	update();
}() );
